import React from 'react';

import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { useNavigation } from '../../../common/navigation';

import { ExamsSpecialistView } from './ExamsSpecialistView';

export const ExamsLaryngologistView: React.FC = () => {
  const nav = useNavigation();

  return (
    <ExamsSpecialistView
      mode="laryngologist"
      articleMode={ArticleMode.Laryngologist}
      tabReadyTitle={'Badania laryngologiczne do obsługi'}
      tabAllTitle={'Wszystkie badania laryngologiczne'}
      onClick={nav.examTestsLaryngologist}
    />
  );
};
